export { MagnetIAPage } from './MagnetIAPage';
